export type NotificationTimeGroup = 'today' | 'yesterday' | 'earlier'

export const NOTIFICATION_TIME_GROUPS: NotificationTimeGroup[] = ['today', 'yesterday', 'earlier']

const DAY_MS = 24 * 3600 * 1000

/**
 * Buckets notifications into Today / Yesterday / Earlier relative to `now`
 * (local calendar days). Input order is preserved inside each bucket; items
 * without a parseable date fall into "earlier" so they are never lost.
 */
export function groupNotificationsByTime<T extends { createdOn: string }>(
    items: readonly T[],
    now: Date = new Date()
): Record<NotificationTimeGroup, T[]> {
    const buckets: Record<NotificationTimeGroup, T[]> = { today: [], yesterday: [], earlier: [] }
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
    const startOfYesterday = startOfToday - DAY_MS

    for (const item of items) {
        const t = new Date(item.createdOn).getTime()
        if (Number.isNaN(t)) buckets.earlier.push(item)
        else if (t >= startOfToday) buckets.today.push(item)
        else if (t >= startOfYesterday) buckets.yesterday.push(item)
        else buckets.earlier.push(item)
    }
    return buckets
}
